import style from './value-section.module.scss';
import template from '@components/careers/vacancies/vacancies.module.scss';
import Image from 'next/image';
import { IValueItem } from '@components/careers/vacancies/vacancies.interfaces';

interface IValueSectionProps {
  title: string;
  subtitle: string;
  items: IValueItem[];
}

const ValueSection = ({ title, subtitle, items }: IValueSectionProps) => {
  return (
    <section className={`${template.section} ${template.section_gray}`}>
      <div className={`${template.container} ${template.container_small} ${template.mb16}`}>
        <div className={`${template.title} ${template.title_large} ${template.text_align_c} ${template.mb20}`}>
          {title}
        </div>
        <div className={`${template.text} ${template.text_color_main} ${template.text_small} ${template.text_align_c}`}>
          {subtitle}
        </div>
      </div>
      <div className={`${template.container} ${template.container_large} ${style.valueSection__items}`}>
        {items.map((item: IValueItem, index: number) => {
          return (
            <div className={`${style.valueSection__item}`} key={index}>
              <div className={`${style.valueSection__item__image} ${template.mb20}`}>
                <Image src={item.iconSrc} width={'60px'} height={'60px'} alt={item.title} />
              </div>
              <div
                className={`${style.valueSection__item__title} ${template.title} ${template.title_middle} ${template.text_align_l} ${template.mb8}`}
              >
                {item.title}
              </div>
              <div
                className={`${style.valueSection__item__text} ${template.text} ${template.text_small} ${template.text_align_l} ${template.text_color_second}`}
              >
                {item.subtitle}
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default ValueSection;
